import logger from '../../utils/logger';
import React from 'react';
import { Shield } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

/**
 * MfaNavbarIndicator Component
 *
 * Compact 2FA status indicator for navbar - subtle and non-intrusive.
 * Displays between logo and right-side icons when 2FA is not enabled.
 */
const MfaNavbarIndicator = ({ onNavigate }) => {
  const { user } = useAuth();

  // Don't render if no user or MFA already enabled
  if (!user || user.mfaEnabled) {
    return null;
  }

  const handleClick = () => {
    if (typeof onNavigate === 'function') {
      onNavigate('settings?tab=security');
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-2 px-3 py-1.5 bg-red-50/80 dark:bg-red-900/20 border border-red-200/60 dark:border-red-800/40 rounded-lg hover:bg-red-100/80 dark:hover:bg-red-900/30 hover:border-red-300/60 dark:hover:border-red-700/50 transition-all duration-200 group focus:outline-none focus:ring-2 focus:ring-red-400/50 focus:ring-offset-1"
      title="Two-Factor Authentication not enabled - Click to set up"
      aria-label="Enable two-factor authentication"
    >
      <Shield
        size={16}
        className="text-red-600 dark:text-red-400 flex-shrink-0"
        aria-hidden="true"
      />
      <span className="text-xs font-medium text-red-700 dark:text-red-300 whitespace-nowrap">
        Enable 2FA
      </span>
    </button>
  );
};

export default MfaNavbarIndicator;
